/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Camera_Unplace_ConfirmInputs */

const vi_camera_unplace_confirm = /** @type {(inputs: Camera_Unplace_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gỡ camera "${i?.name}" khỏi vùng trồng này? Camera vẫn còn trong Danh sách camera để gắn lại.`)
};

/**

* @param {Camera_Unplace_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_unplace_confirm = /** @type {((inputs: Camera_Unplace_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Unplace_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_unplace_confirm(inputs)
});